<template>
  <div>
    <Header :showProductTour="false" />
    <!-- Clinical Trials -->
    <div class="tables-body">
      <h1 class="text-secondary">Clinical Trials</h1>
      <div class="d-flex justify-content-between w-100">
        <MultiSelect
          :options="trialProductOptions"
          placeholder="Add products..."
          :value="selectedTrialProducts"
          @tagChange="onSelectedTrialProductsChange"
        />
        <!-- <MultiSelect
          :options="trials_info_fields"
          placeholder="Select fields..."
          :value="selectedFields"
          @tagChange="onSelectedFieldsChange"
        /> -->
      </div>
      <div class="d-flex flex-wrap">
        <div
          :key="product"
          class="m-2"
          v-for="product in selectedTrialProducts"
        >
          <h2 class="text-secondary">{{ product }}</h2>
          <b-table
            outlined
            striped
            hover
            :fields="trials_info_fields"
            :items="
              trials_info
                .filter((item) => product === item.product)
                .flatMap((prod_item) => prod_item.values)
            "
          >
          </b-table>
        </div>
      </div>
    </div>
    <div class="tables-body">
      <h1 class="text-secondary">Efficacy Endpoints</h1>
      <div class="d-flex justify-content-between w-100">
        <MultiSelect
          :options="endpointProductOptions"
          placeholder="Add products..."
          :value="selectedEndpointProducts"
          @tagChange="onSelectedEndpointProductsChange"
        />
        <!-- <MultiSelect
          :options="trials_info_fields"
          placeholder="Select fields..."
          :value="selectedFields"
          @tagChange="onSelectedFieldsChange"
        /> -->
      </div>
      <!-- Endpoints -->
      <div class="d-flex flex-wrap">
        <div
          :key="product"
          class="m-2"
          v-for="product in selectedEndpointProducts"
        >
          <h2 class="text-secondary">{{ product }}</h2>
          <b-table
            outlined
            striped
            hover
            :fields="endpoints_info_fields"
            :items="
              endpoints_info.filter((item) => product === item.product)[0]
                .values
            "
          >
          </b-table>
        </div>
      </div>
    </div>
    <div class="tables-body">
      <h1 class="text-secondary">Regulatory History</h1>
      <div class="d-flex justify-content-between w-100">
        <MultiSelect
          :options="regHistoryProductOptions"
          placeholder="Add products..."
          :value="selectedRegHistoryProducts"
          @tagChange="onSelectedRegHistoryProductsChange"
        />
        <!-- <MultiSelect
          :options="trials_info_fields"
          placeholder="Select fields..."
          :value="selectedFields"
          @tagChange="onSelectedFieldsChange"
        /> -->
      </div>
      <!-- Endpoints -->
      <div class="d-flex flex-wrap">
        <div
          :key="product"
          class="m-2"
          v-for="product in selectedRegHistoryProducts"
        >
          <h2 class="text-secondary">{{ product }}</h2>
          <b-table
            outlined
            striped
            hover
            :fields="reg_history_info_fields"
            :items="
              reg_history_info.filter((item) => product === item.product)[0]
                .values
            "
          >
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ESService from '@/services/ESService';

const trials_info = [
  {
    product: 'abatacept',
    values: [
      {
        phase: 'Phase 3',
        condition: ['Diabetes', 'Diabetes Mellitus, Type 2'],
        study_type: 'Interventional',
        official_title:
          'Efficacy and Safety of Oral Semaglutide Versus Placebo in Subjects With Type 2 Diabetes and Moderate Renal Impairment',
        nct_id: 'NCT02827708',
        brief_title:
          'Efficacy and Safety of Oral Semaglutide Versus Placebo in Subjects With Type 2 Diabetes and Moderate Renal Impairment',
        completion_date: '2018-05-15',
        url: 'https://clinicaltrials.gov/show/NCT02827708',
        start_date: '2016-09-20',
        enrollment: '324',
      },
    ],
  },
];

const endpoints_info = [
  {
    product: 'abatacept',
    values: [
      {
        phase: 'Phase 3',
        condition: ['Diabetes', 'Diabetes Mellitus, Type 2'],
        study_type: 'Interventional',
        official_title:
          'Efficacy and Safety of Oral Semaglutide Versus Placebo in Subjects With Type 2 Diabetes and Moderate Renal Impairment',
        nct_id: 'NCT02827708',
        brief_title:
          'Efficacy and Safety of Oral Semaglutide Versus Placebo in Subjects With Type 2 Diabetes and Moderate Renal Impairment',
        completion_date: '2018-05-15',
        url: 'https://clinicaltrials.gov/show/NCT02827708',
        start_date: '2016-09-20',
        enrollment: '324',
      },
    ],
  },
];

const reg_history_info = [
  {
    product: 'abatacept',
    values: [
      {
        phase: 'Phase 3',
        condition: ['Diabetes', 'Diabetes Mellitus, Type 2'],
        study_type: 'Interventional',
        official_title:
          'Efficacy and Safety of Oral Semaglutide Versus Placebo in Subjects With Type 2 Diabetes and Moderate Renal Impairment',
        nct_id: 'NCT02827708',
        brief_title:
          'Efficacy and Safety of Oral Semaglutide Versus Placebo in Subjects With Type 2 Diabetes and Moderate Renal Impairment',
        completion_date: '2018-05-15',
        url: 'https://clinicaltrials.gov/show/NCT02827708',
        start_date: '2016-09-20',
        enrollment: '324',
      },
    ],
  },
];

export default {
  name: 'ProductsTablePage',
  components: {
    Header,
    MultiSelect,
  },
  data() {
    return {
      selectedTrialProducts: [],
      trials_info_fields: [],
      trials_info: [],
      trialProductOptions: [],
      selectedEndpointProducts: [],
      endpoints_info_fields: [],
      endpoints_info: [],
      endpointProductOptions: [],
      selectedRegHistoryProducts: [],
      reg_history_info_fields: [],
      reg_history_info: [],
      regHistoryProductOptions: [],
    };
  },
  async created() {
    this.trialProductOptions = await this.getTrialProductOptions();
    this.trials_info = trials_info;
    this.trials_info_fields = [
      'brief_title',
      'condition',
      'phase',
      'study_type',
      'enrollment',
      'start_date',
      'completion_date',
    ];
    this.endpointProductOptions = await this.getEndpointProductOptions();
    this.endpoints_info = endpoints_info;
    this.endpoints_info_fields = [
      'brief_title',
      'condition',
      'phase',
      'study_type',
      'enrollment',
      'start_date',
      'completion_date',
    ];
    this.regHistoryProductOptions = await this.getRegHistoryProductOptions();
    this.reg_history_info = reg_history_info;
    this.reg_history_info_fields = [
      'brief_title',
      'condition',
      'phase',
      'study_type',
      'enrollment',
      'start_date',
      'completion_date',
    ];
  },

  methods: {
    async getTrialProductOptions() {
      const response = await ESService.getDatasetProducts({
        datasetField: 'trials',
      });

      return response.data.aggregations.termsAgg.termsAgg.buckets.map(
        (b) => b.key
      );
    },
    async getEndpointProductOptions() {
      return ['abatacept'];
    },
    async getRegHistoryProductOptions() {
      return ['abatacept'];
    },
    onSelectedTrialProductsChange(value) {
      this.selectedTrialProducts = value;
      this.getDataset('trials', value);
    },
    onSelectedEndpointProductsChange(value) {
      this.selectedEndpointProducts = value;
      this.getDataset('endpoints', value);
    },
    onSelectedRegHistoryProductsChange(value) {
      this.selectedRegHistoryProducts = value;
      this.getDataset('event_tables', value);
    },
    onSelectedFieldsChange(value) {
      this.selectedFields = value;
    },
    async getDataset(datasetField, productNames) {
      productNames.forEach(async (productName) => {
        const response = await ESService.getDataset({
          productName: productName,
          datasetField: datasetField,
        });
        if (datasetField === 'trials') {
          this.trials_info = [];
          response.data.hits.hits.forEach((hit) => {
            this.trials_info.push({
              product: productName,
              values: hit._source.trials,
            });
          });
        }
      });
    },
    async getDatasetProducts(datasetField) {
      const response = await ESService.getDatasetProducts(
        this.getApiArgs({
          datasetField: datasetField,
        })
      );

      const products = response.data.aggregations.termsAgg.termsAgg.buckets.map(
        (b) => b.key
      );

      if (this.datasetField === 'trials') this.trials_info_fields = products;
      else if (this.datasetField === 'endpoints')
        this.endpoints_info_fields = products;
      else if (this.datasetField === 'event_tables')
        this.reg_history_info_fields = products;
    },
  },
};
</script>

<style scoped>
.tables-body {
  margin-top: 130px;
  widows: 100vw;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: start;
}
</style>
